import React from "react";

export function BotaoPermissao(props) {
    const icones = props.icons || [];
    return (
        <button
            title={props.title}
            style={{
                width: props.width || 30,
                height: 30,
                marginBottom: "2px",
                padding: props.icon === "fa fa-eye" ? 4 : 0,
                ...props.style,
            }}
            disabled={props.disabled}
            type="button"
            className={`btn btn-${!!props.colorCondition ? props.theme || "success" : "default"} btn-sm ${props.disabled ? "disabled" : ""}`}
            onClick={() => {
                if(props.errorMessage){
                    return window.alert(props.errorMessage);
                }
                props.setPermissao({ ...props.newValue });
            }}
        >
            {props.icon ? (
                <i className={`${props.icon}`}></i>
            ) : (
                icones.map((icon, i) => <i key={i} className={`${icon.className}`} style={{ fontSize: icon.fontSize, marginLeft: i == 0 ? 0 : 2 }}></i>)
            )}
            {props.text}
        </button>
    );
}
